import { render } from "./ShowRoleComponent.vue?vue&type=template&id=4ece9836"
import script from "./ShowRoleComponent.vue?vue&type=script&lang=js"
export * from "./ShowRoleComponent.vue?vue&type=script&lang=js"
script.render = render

export default script